import {
  EntityLinks,
  ExternalConnection,
  LinkedItemGoal,
  TaskCalendarOverride,
  TaskCalendarOverrideWrite,
} from '@griply/types';
import { GetTaskCalendarSyncCandidatesOptions } from '@griply/utils';
import { useCallback } from 'react';

export type BuildTaskCalendarOverrideWrites = (options: {
  task: GetTaskCalendarSyncCandidatesOptions['task'];
  connections: ExternalConnection[];
  goals: LinkedItemGoal[];
  links?: EntityLinks;
  patch: Partial<TaskCalendarOverride>;
}) => TaskCalendarOverrideWrite[];

export type UseSetTaskCalendarOverrideOptions = {
  connections: ExternalConnection[];
  goals: LinkedItemGoal[];
  links?: EntityLinks;
  // Injected: the write-payload builder lives in @griply/services, which this package may not import.
  buildWrites: BuildTaskCalendarOverrideWrites;
  mutate: (write: TaskCalendarOverrideWrite) => void;
};

export const useSetTaskCalendarOverride = ({
  connections,
  goals,
  links,
  buildWrites,
  mutate,
}: UseSetTaskCalendarOverrideOptions) =>
  useCallback(
    (
      task: GetTaskCalendarSyncCandidatesOptions['task'],
      patch: Partial<TaskCalendarOverride>,
    ) =>
      buildWrites({ task, connections, goals, links, patch }).forEach((write) =>
        mutate(write),
      ),
    [buildWrites, mutate, connections, goals, links],
  );
